<script>
  import Hero from "./hero.svelte";
  import Intro from "./intro.svelte";
  import Price from "./price.svelte";
  import Location from "./location.svelte";
  import Reservation from "./reservation.svelte";
  import Seperator from "./comp/seperator.svelte";
</script>

<main class="container">
  <Hero />
  <Seperator id="intro" />
  <Intro />
  <Seperator id="price" />
  <Price />
  <Seperator id="location" />
  <Location />
  <Seperator id="reservation" />
  <Reservation />
</main>

<style>
  .container {
    width: 100%;
    overflow-x: hidden;
  }
</style>
